module.exports = __webpack_public_path__ + "static/media/nursultan-rakysh-IunHchTIsM8-unsplash.154d8012.jpg";